module.exports = __webpack_public_path__ + "static/media/apucarana.f3e8f496.png";